var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 531.58 184.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    d: "M439.28,132v9.42a10.86,10.86,0,0,1-10.86,10.86H348.77a10.87,10.87,0,0,1-10.86-10.86V132a30.42,30.42,0,0,1,30.41-30.41h3.78a39.39,39.39,0,0,0,33,0h3.78A30.42,30.42,0,0,1,439.28,132ZM359.63,65.37a29,29,0,1,1,29,29A29,29,0,0,1,359.63,65.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M193.67,132v9.42a10.86,10.86,0,0,1-10.86,10.86H103.16A10.87,10.87,0,0,1,92.3,141.4V132a30.42,30.42,0,0,1,30.41-30.41h3.78a39.39,39.39,0,0,0,33,0h3.78A30.42,30.42,0,0,1,193.67,132ZM114,65.37a29,29,0,1,1,29,29A29,29,0,0,1,114,65.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M316.48,132v9.42a10.87,10.87,0,0,1-10.87,10.86H226a10.86,10.86,0,0,1-10.86-10.86V132a30.42,30.42,0,0,1,30.41-30.41h3.77a39.41,39.41,0,0,0,33,0h3.77A30.42,30.42,0,0,1,316.48,132ZM236.83,65.37a29,29,0,1,1,29,29A29,29,0,0,1,236.83,65.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser03);
export default __webpack_public_path__ + "static/media/user_03.c52d949e.svg";
export { ForwardRef as ReactComponent };